import {Component, Input} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@Component({
    selector: 'app-adx-booking-inter-company-line-info',
    templateUrl: './adx-booking-inter-company-line-info.component.html',
    standalone: false
})
@AutoUnsubscribe()
export class AdxBookingInterCompanyLineInfoComponent {
  @Input() data: any;

  get interCompanyLine(): any {
    return this.data ?? {};
  }
}
